import { isGraphPointer } from 'is-graph-pointer';
import { sh } from '@tpluscode/rdf-ns-builders';
import { getOne, getOneOrZero } from './util.js';
import { FocusNodeExpression } from './FocusNodeExpression.js';
import NodeExpressionBase from './NodeExpression.js';
export class FilterShapeExpression extends NodeExpressionBase {
    get requiresFullContext() {
        return this.nodes.requiresFullContext;
    }
    get rootIsFocusNode() {
        return this.nodes.rootIsFocusNode;
    }
    constructor(term, shape, nodes = new FocusNodeExpression()) {
        super();
        this.term = term;
        this.shape = shape;
        this.nodes = nodes;
    }
    static match(pointer) {
        return isGraphPointer(pointer.out(sh.filterShape));
    }
    static fromPointer(pointer, factory) {
        const filterShape = factory.nodeShape(getOne(pointer, sh.filterShape));
        const nodes = getOneOrZero(pointer, sh.nodes);
        if (nodes) {
            return new FilterShapeExpression(pointer.term, filterShape, factory.nodeExpression(nodes));
        }
        return new FilterShapeExpression(pointer.term, filterShape);
    }
    _buildPatterns({ subject, variable, rootPatterns, object }, builder) {
        let focusNode = subject;
        let patterns = [];
        let valueNode;
        if (this.nodes instanceof FocusNodeExpression) {
            valueNode = object;
        }
        else {
            ({ patterns, object: focusNode } = builder.build(this.nodes, { subject, object, variable, rootPatterns }));
            valueNode = variable();
        }
        return [
            ...patterns,
            ...this.shape.buildConstraints({ focusNode, valueNode, variable, rootPatterns }),
        ];
    }
}
